import { create } from 'zustand';
import { PageStatus } from '../types/enums/PageStatus';
import { ForceLogoutException, NetworkException } from '../utils/apiException';

interface PageStore {
  status: PageStatus;
  data?: Object;
  error?: Error;
}

interface PageActions {
  load: () => Promise<void>;
  fetchData: () => Promise<Object>;
  reset: () => void;
}

export const createPageStore = (fetchDataFn: () => Promise<Object>) =>
  create<PageStore & PageActions>((set, get) => ({
    status: PageStatus.Initial,
    load: async () => {
      set({ status: PageStatus.Loading });
      try {
        const data = await get().fetchData();
        set({ status: PageStatus.Loaded, data });
      } catch (error) {
        if (error instanceof NetworkException) {
          set({ status: PageStatus.ConnectionError });
        } else if (error instanceof ForceLogoutException) {
          set({ status: PageStatus.ForceLogout });
        } else {
          set({ status: PageStatus.Error });
        }
      }
    },
    reset: () => {
      set({
        status: PageStatus.Initial,
        data: undefined,
        error: undefined,
      });
    },
    fetchData: fetchDataFn,
  }));
